export const LoginService = async () => {
  return {
    id: 4,
    username: "bob",
    email: "bob@bob.com",
  };
};
